import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficioEsquerdaComponent } from './beneficio-esquerda.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    BeneficioEsquerdaComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    BeneficioEsquerdaComponent
  ]
})

export class BeneficioEsquerdaModule { }
